// extracted by mini-css-extract-plugin
export var linkText = "_nj-0";